<template>
  <main class="d-flex flex-column align-items-center gap-32 freeSend">
    <template v-if="products">
      
      <img 
        class="d-md-block d-none"
        src="../../../assets/images/freeSendDesktopPage.jpg"
        alt="ارسال رایگان بندیتو"
      />
      <!-- <img v-if="content.settings.free_shipping&&content.settings.free_shipping.free_shipping_desktop_banner"
        class="d-md-block d-none"
        :src="`https://api.benedito.ir/storage/${content.settings.free_shipping.free_shipping_desktop_banner}`"
        alt="ارسال رایگان بندیتو"
      /> -->
      <!-- <Skeleton class="skeleton-banner " v-else></Skeleton> -->
      <img 
        class="d-block d-md-none"
        src="../../../assets/images/freeSendMobilePage.jpg"
        alt="ارسال رایگان بندیتو"
      />
      <!-- <img v-if="content.settings.free_shipping&&content.settings.free_shipping.free_shipping_mobile_banner"
        class="d-block d-md-none"
        :src="`https://api.benedito.ir/storage/${content.settings.free_shipping.free_shipping_mobile_banner}`"
        alt="ارسال رایگان بندیتو"
      /> -->
      <!-- <Skeleton class="skeleton-banner " v-else></Skeleton> -->
    </template>
    <Skeleton class="skeleton-banner " v-else></Skeleton>

    <template v-if="products">
      <div v-if="products.length" id="freeProducts">
        <Product class="w-100"
          v-for="(product, index) in products"
          :key="index"
          :product="product"
        />
      </div>
      <p v-else>محصولی برای نمایش وجود ندارد</p>
    </template>
    <Skeleton v-else class="skeleton-peoduct-content">
    <Skeleton class="skeleton-product bg-skeleton-item" v-for="i in 8" :key="i"></Skeleton>

    </Skeleton>
  </main>
</template>
<script>
import Product from "@/parts/Front/components/product/Product";
export default {
  components: {
    Product,
  },
  data(){
    return {
      timeout,
      bannerItem:false
    }
  },
  created() {
    if (!this.products) {
      this.$store.dispatch("front/getFreeShippingProductsFromDB");
    }
    
  },
  methods:{
    showBanner(url){
      // if(url&&url!=""){
        // setTimeout(() => {
        //   console.log(123);
        //   return true
        // }, 300);
        this.timeout = setTimeout(alertFunc, 300);
    },
    alertFunc(){

      this.bannerItem=true
    }
  },
  computed: {
    products() {
      return this.$store.getters["front/getFreeShippingProducts"];
    },
    content() {
      return this.$store.getters["front/getHomeData"];
    },
  },
};
</script>
<style scoped>
.skeleton-banner{
  height: 473px;
}
.skeleton-peoduct-content{
  height: fit-content;
}
.skeleton-peoduct-content .skeleton-product{
  height: 535px;
  width: 100%;
}
.freeSend {
  width: 90%;
  margin: 24px auto;
}
.skeleton-peoduct-content{
  width: 100%;
}
div#freeProducts , .skeleton-peoduct-content{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 16px;
  width: 100%;

}
main > q {
  font-size: 24px;
  text-align: center;
}
@media (max-width: 768px) {
  div#freeProducts ,.skeleton-peoduct-content{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 580px) {
  .skeleton-banner{
    height: 231px;
  }
  .skeleton-peoduct-content .skeleton-product{
    height: 323px;
  }
  div#freeProducts ,.skeleton-peoduct-content{
    display: grid;
    grid-template-columns: repeat(2, 48%);
  }
  main > q {
    font-size: 20px;
  }
}
main > img {
  width: 100%;
}
</style>
<style>
div#freeProducts article {
  overflow: hidden;
  box-shadow: 0 0 10px #989898;
}
</style>
